"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cachedGetResult(target, _propertyKey, descriptor) {
    var originGetter = descriptor.get;
    descriptor.get = (function () {
        var value;
        return function () {
            if (value === undefined) {
                value = originGetter.call(target);
            }
            return value;
        };
    })();
}
exports.default = cachedGetResult;
